import { Injectable } from '@angular/core';
import { UtilitiesService } from '../utilities/utilities.service';
declare var AdjustEvent: any;
declare var Adjust: any;
@Injectable({
  providedIn: 'root'
})
export class AdjustTokenService {

  constructor(private UTS: UtilitiesService) { }

  trackEvent(eventToken: string) {
    try {
      var adjustEvent = new AdjustEvent(eventToken);
      Adjust.trackEvent(adjustEvent);
    } catch (error) {
      console.log('Adjust SDK is not available or failed to track event:', error);
    }
  }
  isLoginUser(): boolean {
    const isLogin = localStorage.getItem('ISLOGIN');
    if (isLogin) {
      return true;
    }
    else {
      return false;
    }
  }
  getItemCatType(item: any) {
    let type;
    if (item?.productType == 'MOBILE_CONTROLLINE')
      return type = item?.commerceItemCategory;
    else if (item?.productType == 'MOBILE_POSTPAID')
      return type = 'Postpaid plans';
    else if (item?.productType == 'MOBILE_VISITOR_PREPAID')
      return type = 'Visitor Line';
    else if (item?.productType == 'MOBILE_PREPAID')
      return type = 'Prepaid plans';
    else if (item?.commerceItemType == 'etsElifeSku')
      return type = 'eLife_plan';
    else if (item?.typeOfProduct)
      return type = item?.typeOfProduct;
    else
      return type = item?.commerceItemCategory;
  }
  devicesAdjustTracking(name, eventToken, element) {
    const UserStatus = this.isLoginUser() ? 'Logged In' : 'Guest';
    const UserId = (this.UTS.getUserId()) ? this.UTS.getUserId() : '';
    let item: any = {
      ItemId: element?.skuId,// Capture the SKU ID of the plan
      ItemName: element?.displayName,
      ItemBrand: element?.brand ? element?.brand : "Etisalat",
      ItemCategory: this.getItemCatType(element) || '',
      ItemSubcategory: this.getItemCatType(element) || '',
      ItemPrice: element?.paymentOptions?.price ? element?.paymentOptions?.price : element?.price?.oneTime, //Price of the plan
    }
    // Build item_features string from configurations
    let itemFeatures = '';
    if (element?.configurations?.length) {
      itemFeatures = element.configurations
        .filter(c => c?.type === "Colour" || c?.type === "Memory")
        .map(config => config?.name)
        .join(' | ');
    }
    item.ItemFeatures = itemFeatures;
    this.trackEventDetails(eventToken, item.ItemId, item.ItemName, item.ItemCategory, item.ItemSubcategory, item.ItemBrand, item.ItemPrice, UserId, UserStatus, item.ItemFeatures);
  }
  trackEventDetails(eventToken, ItemId, ItemName, ItemCategory, ItemSubcategory, ItemBrand, ItemPrice, UserId, UserStatus, itemFeatures) {
    var adjustEvent = new AdjustEvent(eventToken);
    // Adding Callback Parameters
    adjustEvent.addCallbackParameter("item_id", ItemId);
    adjustEvent.addCallbackParameter("item_name", ItemName);
    adjustEvent.addCallbackParameter("item_category", ItemCategory);
    adjustEvent.addCallbackParameter("item_subcategory", ItemSubcategory)
    adjustEvent.addCallbackParameter("item_brand", ItemBrand)
    adjustEvent.addCallbackParameter("item_currency", "AED")
    adjustEvent.addCallbackParameter("item_price", ItemPrice)
    adjustEvent.addCallbackParameter("item_features", itemFeatures)
    adjustEvent.addCallbackParameter("user_id", UserId)
    adjustEvent.addCallbackParameter("user_status", UserStatus)
    // Adding Partner Parameters
    adjustEvent.addPartnerParameter("item_id", ItemId);
    adjustEvent.addPartnerParameter("item_name", ItemName);
    adjustEvent.addPartnerParameter("item_category", ItemCategory);
    adjustEvent.addPartnerParameter("item_subcategory", ItemSubcategory)
    adjustEvent.addPartnerParameter("item_brand", ItemBrand)
    adjustEvent.addPartnerParameter("item_currency", "AED")
    adjustEvent.addPartnerParameter("item_price", ItemPrice)
    adjustEvent.addPartnerParameter("item_features", itemFeatures)
    adjustEvent.addPartnerParameter("user_id", UserId)
    adjustEvent.addPartnerParameter("user_status", UserStatus)
    Adjust.trackEvent(adjustEvent)
  }
}

